
import { createBrowserRouter } from 'react-router-dom';
import Mainhome from './components/Mainhome';
import Layout from './Layout';
import Blog from './components/Blog';
import Doctor from './components/WorkAll/Doctor';
import Harper from './components/WorkAll/Harper';
import Learn from './components/WorkAll/Learn';
import Convert from './components/WorkAll/Convert';

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout></Layout>,
        children:[
            {
                path : '/',
                element: <Mainhome></Mainhome>
            },
            {
                path: '/blog',
                element: <Blog></Blog>
            },
            {
                path: '/work/1',
                element: <Doctor></Doctor>
            },
            {
                path: '/work/2',
                element: <Learn></Learn>
            },
            {
                path: '/work/3',
                element: <Harper></Harper>
            },
            {
                path: '/work/4',
                element: <Convert></Convert>
            },

        ]
    }
])



export default router;